import React, { useState, useCallback, useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import logo from '../../images/shiphawk-logo-navy-retina.png';
import styles from '../styles.module.css';
import { login, fetchAuthFlow } from '../SignIn/actions.js';
import BasicSignIn from '../SignIn/components/BasicSignIn.js';
import EmailSignIn from '../SignIn/components/EmailSignIn.js';
import TwoFactorSignIn from '../SignIn/components/TwoFactorSignIn.js';

function WorkstationSignIn() {
  const location = useLocation();
  const { workstation_code: workstationCode } = useParams();
  const [isOtpRequired, setIsOtpRequired] = useState(false);
  const [otpDetails, setOtpDetails] = useState({});
  const [authStep, setAuthStep] = useState('email'); // 'email', 'password'
  const [userEmail, setUserEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlError = searchParams.get('error');
    if (urlError) {
      setError(decodeURIComponent(urlError));
    }
  }, [location.search]);

  const setAuthFlow = useCallback((data) => {
    if (data) {
      if (data.flow === 'password') {
        setAuthStep('password');
      } else if (data.flow === 'saml' && data.sso_url) {
        window.location.href = data.sso_url;
      }
    }
  }, []);

  const handleEmailSubmit = useCallback(
    async (email) => {
      setError('');
      setUserEmail(email);
      fetchAuthFlow({
        email,
        setError,
        setAuthFlow,
        workstationCode,
      });
    },
    [workstationCode],
  );

  const handleBackToEmail = useCallback((e) => {
    e.preventDefault();
    setAuthStep('email');
    setUserEmail('');
    setError('');
    setIsOtpRequired(false);
    setOtpDetails({});
  }, []);

  const submitCallback = useCallback(
    (data) =>
      login({
        ...data,
        setIsOtpRequired,
        setOtpDetails,
        workstationCode,
      }),
    [workstationCode],
  );

  const { requiredAction } = otpDetails;

  const showEmailForm = authStep === 'email';
  const showPasswordForm =
    authStep === 'password' && (!isOtpRequired || requiredAction);
  const showTwoFactorForm =
    authStep === 'password' && isOtpRequired && !requiredAction;

  return (
    <div className={styles.container}>
      <Link to={`/workstation/${workstationCode}/sign-in`}>
        <img data-testid="logoLink" className={styles.logo} alt="" src={logo} />
      </Link>

      {showEmailForm && (
        <EmailSignIn onEmailSubmit={handleEmailSubmit} error={error} />
      )}

      {showPasswordForm && (
        <BasicSignIn
          submit={submitCallback}
          warning={requiredAction}
          email={userEmail}
          onBackToEmail={handleBackToEmail}
        />
      )}

      {showTwoFactorForm && (
        <TwoFactorSignIn otpDetails={otpDetails} submit={submitCallback} />
      )}
    </div>
  );
}

export default WorkstationSignIn;
